export default ({ dropdown }) => ({
  root: {
    fontFamily: dropdown.fontFamily,
    marginBottom: 20
  },
  wrapper: {
    position: 'relative'
  }
});
